import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { form, viewForm } from "../Apis/form";

const initialState = {
  data: [], // Holds the fetched contact data
  totalRecords: 0, // Total number of records
  totalPages: 0, // Total number of pages
  currentPage: 1, // Current page number
  pageSize: 10, // Number of records per page
  loading: false, // Loading state
  error: null, // Error message
};

// Async thunk to add a contact form
export const addForm = createAsyncThunk(
  "contactUs/register",
  async (credentials, { rejectWithValue }) => {
    try {
      const { name, mobile, city, message } = credentials;
      const response = await form(name, mobile, city, message);
      return response; // Return the newly added form data
    } catch (error) {
      return rejectWithValue(error.response?.data || "Form submission failed");
    }
  }
);

export const fetchContactUs = createAsyncThunk(
  "contactUs/view",
  async (
    { page, pageSize, searchTerm, startDate, endDate },
    { rejectWithValue }
  ) => {
    try {
      const response = await viewForm(
        page,
        pageSize,
        searchTerm,
        startDate,
        endDate
      );
      return response;
    } catch (error) {
      const errorMessage =
        error?.response?.data || error.message || "Failed to fetch data";
      return rejectWithValue(errorMessage);
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle addForm cases
      .addCase(addForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addForm.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "Contact Submitted";

        state.contactData.unshift(action.payload);
        state.totalRecords += 1;

        if (state.totalRecords % state.pageSize === 0) {
          state.totalPages += 1;
        }
      })
      .addCase(addForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      // Handle fetchContactUs cases
      .addCase(fetchContactUs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContactUs.fulfilled, (state, action) => {
        state.loading = false;
        state.contactData = action.payload.data; // Update the data array
        state.totalRecords = action.payload.totalRecords;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
        state.pageSize = action.payload.pageSize;
      })
      .addCase(fetchContactUs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contactSlice.reducer;
